const translations = {
    button: 'Save',
    title: 'Company Details'
};

export default translations;
